function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25693"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4102.141 262.497a109.928 109.928 0 10.01 0zm0 210.03a100.84 100.84 0 11100.84-100.84 100.832 100.832 0 01-100.84 100.79z",
  fill: "#0b0b14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4064.076 423.724v-106.46h49.79a35.706 35.706 0 0126.15 9.58 33.137 33.137 0 019.81 24.69 37.094 37.094 0 01-2.06 12.35 28.556 28.556 0 01-5.45 9.47 33.814 33.814 0 01-7.46 6.24 29.5 29.5 0 01-8.5 3.54l24.06 40.52h-26.2l-20.9-37.79h-16.5v37.79zm22.64-57.75h23.94a16.5 16.5 0 0011.32-3.93 13.542 13.542 0 004.51-10.66 12.955 12.955 0 00-4.51-10.29 16.739 16.739 0 00-11.32-3.87h-23.85z",
  fill: "#0b0b14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.41 1.56h172.86l-123.86 478.72H988.55zM2947.96 1.56h172.86l-123.87 478.72h-172.86zM1335.7 53.49l-11.22 35.57 482.72 1.47-576.01 388.54 760.93 1.68a74.388 74.388 0 0072.28-56.06l7.92-31.1-364.93-1.27L2166.82 0l-760.3 1.45a74.427 74.427 0 00-70.82 52.04zM2266.94 0h625.38l-9.92 35.91a74.441 74.441 0 01-71.75 54.63H2659.3l-98.41 388.23-256.29 2.12 103-390.35h-221.72l9-34.76A74.436 74.436 0 012266.94 0zM3201.34 2.08h331.1l121.49 139.65L3912.42 2.08h226.07L3735.85 235.9l213.12 244.98h-331.12l-105.24-116.27-198.58 115.65-285.36.57 400.62-216.71z",
  fill: "#010011"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.69 193.83h398.73a18.6 18.6 0 0118.01 23.25l-62.85 242.95a22.334 22.334 0 01-40.96 5.58l-93.17-161.14-225.6-74.38a18.6 18.6 0 015.84-36.26z",
  fill: "#d90101"
}), /*#__PURE__*/React.createElement("path", {
  d: "M282.32 1.17A260.487 260.487 0 0030.14 196.4L4.78 294.49a148.858 148.858 0 00144.17 186.14l261.35-.14 363.78-.14a179.053 179.053 0 00-153.82-88.03H403.68a74.375 74.375 0 01-72.02-93.04l25.12-97.16A148.872 148.872 0 01500.83 90.56h417.63A111.644 111.644 0 001026.5 6.88l1.47-5.67z",
  fill: "#010011"
}));

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4211.401 480.917"
  }, props), _ref);
}

export default SvgLogo;